<div class="header-title">
  <div class="flex u-align-items-center u-pa-20">
    <div class="flex flex-align-center">
      <a routerLink="/button" aria-label="back" class="u-button u-button--link u-button--back u-button-icon-left u-ma-0 u-button--auto"
        type="button">
        <span class="u-icon icon-chevron-left"></span>
        <span class="u-button-text">Back</span>
      </a>
    </div>
    <div class="page-title flex u-w-100 u-justify-content-center u-position-absolute u-position-left">
      <h1 class="font-semibold u-ma-0 flex header-title--name">Hot Corner
      </h1>
    </div>
  </div>
  <div class="c-header__gradient"></div>
</div>

<div class="content">
  <h2><strong>Note:</strong> This component is only work in IWB screen form 1920px and above. It is use here for view purpose only </h2>
  <div class="c-hot-corner">
    <maced-hot-corner (selectedHotCorner)="getHotCorner($event)" [positionContent]="positionContent"></maced-hot-corner>
  </div>  
  
</div>